//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import InputSuccessIcon from '../../../../../common/icons/InputSuccessIcon';
import ProgressBar from '../../../../../data_ingestion/ProgressBar';

export default {
  name: 'DataImport',
  components: {
    ProgressBar,
    InputSuccessIcon,
  },
  props: {
    importId: {
      type: String,
      required: true,
    },
    avoid: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    hotDataIsLoading(val) {
      console.log('hotDataIsLoading', val);
      if (!val || this.avoid) {
        this.$emit('complete');
      }
    },
  },
  computed: {
    ...mapGetters(['hotDataIsLoading']),
  },
};
